// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"style-module_listTitle__1wilGiu7rWP0RpIzh614Nt"};